import { currentAPI, walletAPI, trivialGameAPI, billsAPI, BILL_AUTH_KEY } from './API';
import axios from './axios';

export { currentAPI, walletAPI, trivialGameAPI, axios, billsAPI, BILL_AUTH_KEY };
